import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4168f8b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-fluid sortRow align-items-center" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "resultsHeader" }
const _hoisted_5 = {
  key: 0,
  class: "col d-none d-sm-block sortDropDown"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "sortLabel" }, "Sort By", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "default" }, "Default", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "apy" }, "APY", -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "col d-block d-sm-none sortCol text-right"
}
const _hoisted_11 = {
  href: "",
  "data-toggle": "modal",
  "data-target": "#sortFilterModal"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-12 ad-disclosure-div-new pr-0" }
const _hoisted_15 = { class: "tooltipdata pull-left" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"4px","padding-right":"4px","color":"#aaa"} }, " | ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "d-none d-sm-block" }, null, -1))
const _hoisted_18 = {
  key: 0,
  class: "hr-mobile-seperator d-block d-sm-none row",
  style: {"margin-top":"1rem"}
}
const _hoisted_19 = { class: "rateTableContainer" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-sm resultsCol" }
const _hoisted_22 = { class: "sponsoredResults" }
const _hoisted_23 = ["title"]
const _hoisted_24 = {
  key: 0,
  class: "row",
  style: {"margin-top":"5px"}
}
const _hoisted_25 = { class: "col-sm resultsCol" }
const _hoisted_26 = { class: "sponsoredResults-ad" }
const _hoisted_27 = { class: "rateTable col-fluid" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr-separator d-none d-sm-block" }, null, -1))
const _hoisted_29 = {
  key: 0,
  class: "compareToLabel"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr-separator d-none d-sm-block" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr-separator d-none d-sm-block" }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row allResultsRow" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm resultsCol" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "allResults" }, [
      /*#__PURE__*/_createElementVNode("b", null, "All Results")
    ])
  ])
], -1))
const _hoisted_33 = { class: "rateTable" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "hr-separator d-none d-sm-block" }, null, -1))
const _hoisted_35 = {
  key: 0,
  class: "showMoreResults"
}
const _hoisted_36 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_how_da_get_paid = _resolveComponent("how-da-get-paid")!
  const _component_ad_disclosure = _resolveComponent("ad-disclosure")!
  const _component_rate_table_row = _resolveComponent("rate-table-row")!
  const _component_rate_table_bank_modal = _resolveComponent("rate-table-bank-modal")!
  const _component_rate_table_sort_modal = _resolveComponent("rate-table-sort-modal")!
  const _component_rate_table_friction_modal = _resolveComponent("rate-table-friction-modal")!
  const _component_ad_disclosure_modal = _resolveComponent("ad-disclosure-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, [
            _renderSlot(_ctx.$slots, "rate-table-title", {}, undefined, true)
          ])
        ]),
        (_ctx.showSortFilter && !_ctx.isWp)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("select", {
                class: "form-control",
                name: "sort",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.sort) = $event))
              }, _hoisted_9, 512), [
                [_vModelSelect, _ctx.filter.sort]
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isWp)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("a", _hoisted_11, [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'filter'] }),
                _createTextVNode(" Filter "),
                (_ctx.showSortFilter)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "/ Sort"))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_how_da_get_paid),
            _createTextVNode(),
            _hoisted_16,
            _createTextVNode(),
            _createVNode(_component_ad_disclosure)
          ])
        ])
      ], 512), [
        [_vShow, _ctx.isWp]
      ]),
      _hoisted_17,
      (_ctx.isWp)
        ? (_openBlock(), _createElementBlock("hr", _hoisted_18))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_19, [
      (_ctx.isTopZoneComing)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("div", _hoisted_22, [
                  _createTextVNode(_toDisplayString(_ctx.numPlacements) + " " + _toDisplayString(_ctx.numPlacements > 1 ? 'Sponsored Results' : 'Sponsored Result') + " ", 1),
                  _createElementVNode("span", {
                    class: "da-tooltip-span",
                    style: {"cursor":"pointer"},
                    title: _ctx.addisclosureText
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['far', 'question-circle'] })
                  ], 8, _hoisted_23)
                ], 512), [
                  [_vShow, !_ctx.isWp]
                ])
              ])
            ]),
            (!_ctx.isWp)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_how_da_get_paid)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_27, [
              (_ctx.isExperienceB)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sponsoredOnly, (account, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        style: {"cursor":"default"},
                        key: index
                      }, [
                        _createVNode(_component_rate_table_row, {
                          account: account,
                          ad: _ctx.filterPlacement(account.clickUrl),
                          isWp: _ctx.isWp,
                          labelCTAButton: _ctx.labelCTAButton,
                          CTAButtonColor: _ctx.CTAButtonColor,
                          showDepositAmountAndEstEarning: _ctx.showDepositAmountAndEstEarning,
                          showAdCopy: _ctx.showAdCopy,
                          frictionLevel: _ctx.frictionLevel
                        }, null, 8, ["account", "ad", "isWp", "labelCTAButton", "CTAButtonColor", "showDepositAmountAndEstEarning", "showAdCopy", "frictionLevel"]),
                        _hoisted_28
                      ]))
                    }), 128)),
                    (Object.keys(_ctx.nonSponsoredOnly).length > 0)
                      ? (_openBlock(), _createElementBlock("h4", _hoisted_29, "Compare to:"))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nonSponsoredOnly, (account) => {
                      return (_openBlock(), _createElementBlock("div", {
                        style: {"cursor":"default"},
                        key: account.id
                      }, [
                        _createVNode(_component_rate_table_row, {
                          account: account,
                          ad: _ctx.filterPlacement(account.clickUrl),
                          isWp: _ctx.isWp,
                          labelCTAButton: _ctx.labelCTAButton,
                          CTAButtonColor: _ctx.CTAButtonColor,
                          showDepositAmountAndEstEarning: _ctx.showDepositAmountAndEstEarning,
                          showAdCopy: _ctx.showAdCopy,
                          frictionLevel: _ctx.frictionLevel,
                          isExperienceB: true
                        }, null, 8, ["account", "ad", "isWp", "labelCTAButton", "CTAButtonColor", "showDepositAmountAndEstEarning", "showAdCopy", "frictionLevel"]),
                        _hoisted_30
                      ]))
                    }), 128))
                  ], 64))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.topZoneAccounts, (account, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      style: {"cursor":"default"},
                      key: index
                    }, [
                      _createVNode(_component_rate_table_row, {
                        account: account,
                        ad: _ctx.filterPlacement(account.clickUrl),
                        isWp: _ctx.isWp,
                        labelCTAButton: _ctx.labelCTAButton,
                        CTAButtonColor: _ctx.CTAButtonColor,
                        showDepositAmountAndEstEarning: _ctx.showDepositAmountAndEstEarning,
                        showAdCopy: _ctx.showAdCopy,
                        frictionLevel: _ctx.frictionLevel
                      }, null, 8, ["account", "ad", "isWp", "labelCTAButton", "CTAButtonColor", "showDepositAmountAndEstEarning", "showAdCopy", "frictionLevel"]),
                      _hoisted_31
                    ]))
                  }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.isBottomZoneComing)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bottomZoneAccounts, (account, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  style: {"cursor":"default"},
                  key: index
                }, [
                  _createVNode(_component_rate_table_row, {
                    account: account,
                    ad: _ctx.filterPlacement(account.clickUrl),
                    isWp: _ctx.isWp,
                    labelCTAButton: _ctx.labelCTAButton,
                    CTAButtonColor: _ctx.CTAButtonColor,
                    showDepositAmountAndEstEarning: _ctx.showDepositAmountAndEstEarning,
                    showAdCopy: _ctx.showAdCopy,
                    frictionLevel: _ctx.frictionLevel
                  }, null, 8, ["account", "ad", "isWp", "labelCTAButton", "CTAButtonColor", "showDepositAmountAndEstEarning", "showAdCopy", "frictionLevel"]),
                  _hoisted_34
                ]))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.moreResults > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          (_ctx.showMoreResultsVisible)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "showMoreResultsText",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMoreResults()))
              }, "Show " + _toDisplayString(_ctx.moreResults) + " More Results", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_36, "Loading..."))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_rate_table_bank_modal, {
      account: _ctx.selectedAccount,
      ad: _ctx.filterPlacement(_ctx.selectedAccount.clickUrl)
    }, null, 8, ["account", "ad"]),
    _createVNode(_component_rate_table_sort_modal, {
      filter: _ctx.filter,
      showFilters: _ctx.showFilters,
      showSortFilter: _ctx.showSortFilter,
      showRegionFilter: _ctx.showRegionFilter
    }, null, 8, ["filter", "showFilters", "showSortFilter", "showRegionFilter"]),
    _createVNode(_component_rate_table_friction_modal, {
      frictionLevel: _ctx.frictionLevel,
      placement: _ctx.selectedAd,
      CTAButtonColor: _ctx.CTAButtonColor
    }, null, 8, ["frictionLevel", "placement", "CTAButtonColor"]),
    (_ctx.showAdDisclosure)
      ? (_openBlock(), _createBlock(_component_ad_disclosure_modal, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}